import { useI18n } from "@/i18n";
import { Reveal } from "./Reveal";
import { ClipImage } from "./ClipImage";

export const About = () => {
  const { t } = useI18n();
  const a = t.about;
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-40">
      <div className="wrap grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal><p className="eyebrow flex items-center gap-3"><span className="h-px w-8 bg-signal" />{a.label}</p></Reveal>
          <Reveal delay={0.1} className="mt-10">
            <ClipImage src="/img/tallinn.jpg" alt={a.imgAlt} className="aspect-[4/3] lg:aspect-[4/5]" testId="about-image" />
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal as="h2" className="font-display text-3xl font-medium leading-[1.08] tracking-[-0.025em] sm:text-4xl lg:text-[3.4rem]">
            {a.title}
          </Reveal>
          <div className="mt-12 grid gap-8 md:grid-cols-2">
            {a.body.map((p, i) => (
              <Reveal key={p.slice(0, 20)} delay={0.08 * i} as="p" className="text-base leading-relaxed text-zinc-300">{p}</Reveal>
            ))}
          </div>
          <dl data-testid="about-facts" className="mt-16 grid grid-cols-1 border-t border-white/10 sm:grid-cols-2">
            {a.facts.map((f, i) => (
              <Reveal key={f.k} delay={0.06 * i} className={`border-b border-white/10 py-6 ${i % 2 === 0 ? "sm:border-r sm:pr-6" : "sm:pl-6"}`}>
                <dt className="eyebrow">{f.k}</dt>
                <dd className="mt-2 font-display text-xl tracking-tight">{f.v}</dd>
              </Reveal>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};
